<template>
  <section>
    <div class="gift-card-button-wrapper justify-start">
      <div class="search-input">
        <SearchAndFilter
          :placeholder="'Search by email or code'"
          @input="onSearchSearch"
        />
      </div>
      <div class="flex gap-4">
        <button
          class="whitebutton-gemnote whitebutton-gemnote--small"
          @click="onExportGiftCards"
        >
          <span> Export</span>
        </button>

        <button
          class="button-gemnote full-width button-gemnote--small"
          @click="$router.push({ name: 'EcommerceGiftCardCreate' })"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 0L6 13" stroke="#F5F2EE" />
            <path d="M0 6.5L13 6.5" stroke="#F5F2EE" />
          </svg>

          <span>Add gift card</span>
        </button>
      </div>
    </div>
    <!-- Filter -->
    <div class="filters margin-bottom-1">
      <div class="flex flex-col">
        <div class="flex items-center">
          <img src="../../assets/filter-icon.svg" alt="" />
          <div class="dateFilter">
            <v-select
              class="light gift-card"
              :options="filterOptions"
              maxHeight="200px"
              :clearable="false"
              :searchable="false"
              v-model="currentFilter"
              @input="onFilterChange"
              :placeholder="'Filter By'"
            >
              <template #selected-option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <p class="small" style="font-size: 0.89rem;">Filter By</p>
                </div>
              </template>
              <template #option="{ label, text }">
                <div class="flex" style="gap: 1.6rem">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      :checked="currentFilter.text == text"
                    />
                    <span class="checkmark top"></span>
                  </label>
                  <span
                    style="position: relative; top: 0.2rem; font-size: 13px"
                    >{{ label }}</span
                  >
                </div>
              </template>
              <template #open-indicator="{ attributes }">
                <span
                  v-bind="attributes"
                  style="position: relative; left: -28px"
                >
                  <svg
                    width="9"
                    height="5"
                    viewBox="0 0 9 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
                      fill="#25282A"
                    />
                  </svg>
                </span>
              </template>
            </v-select>
          </div>
          <div
            class="flex items-center justify-center"
            style="position: relative; left: -26px;"
            v-if="filterActive"
          >
            <div class="filter-tag">
              <span class="filter-tag-text"> {{ currentFilter.label }} </span>
              <span class="remove" @click="removeFilterTag">X</span>
            </div>
          </div>
        </div>

        <!-- Sort -->
        <div class="flex items-center">
          <img src="../../assets/sort-icon.svg" alt="" />
          <div class="dateFilter">
            <v-select
              class="light gift-card"
              :options="sortOptions"
              :clearable="false"
              :searchable="false"
              v-model="currentSort"
              @input="onSort"
              :placeholder="'Sort By'"
            >
              <template #selected-option="{ label }">
                <div style="display: flex; align-items: baseline">
                  <p class="small" style="font-size: 0.89rem;">Sort By</p>
                </div>
              </template>
              <template #option="{ label, id, text, showArrow }">
                <div class="flex items-center gap-2">
                  <radio-button
                    class="is-gift-card"
                    :label="label"
                    :modelValue="text"
                    :value="text"
                    v-model="currentSort.text"
                    :isGroupOrder="false"
                    custom-styles="font-size: 13px"
                  />
                  <span v-if="showArrow.show">
                    <span v-if="showArrow.state === 'ascending'">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="10"
                        viewBox="0 0 8 10"
                        fill="none"
                      >
                        <path
                          d="M4.35355 0.646446C4.15829 0.451184 3.84171 0.451184 3.64645 0.646446L0.464466 3.82843C0.269204 4.02369 0.269204 4.34027 0.464466 4.53553C0.659728 4.7308 0.97631 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 10L4.5 1L3.5 1L3.5 10L4.5 10Z"
                          fill="#232220"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="10"
                        viewBox="0 0 8 10"
                        fill="none"
                      >
                        <path
                          d="M3.64645 9.35355C3.84171 9.54882 4.15829 9.54882 4.35355 9.35355L7.53553 6.17157C7.7308 5.97631 7.7308 5.65973 7.53553 5.46447C7.34027 5.2692 7.02369 5.2692 6.82843 5.46447L4 8.29289L1.17157 5.46447C0.976311 5.2692 0.659728 5.2692 0.464466 5.46447C0.269204 5.65973 0.269204 5.97631 0.464466 6.17157L3.64645 9.35355ZM3.5 0L3.5 9H4.5L4.5 0L3.5 0Z"
                          fill="#232220"
                        />
                      </svg>
                    </span>
                  </span>
                </div>
              </template>
              <template #open-indicator="{ attributes }">
                <span
                  v-bind="attributes"
                  style="position: relative; left: -34px"
                >
                  <svg
                    width="9"
                    height="5"
                    viewBox="0 0 9 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
                      fill="#25282A"
                    />
                  </svg>
                </span>
              </template>
            </v-select>
          </div>
          <div
            class="flex items-center justify-center"
            style="position: relative; left: -26px;"
            v-if="sortActive"
          >
            <div class="filter-tag">
              <span class="filter-tag-text"> {{ currentSort.label }} </span>
              <span
                class="remove"
                v-if="currentSort.label !== 'None'"
                @click="removeSortTag"
                >X</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Action Button Region here-->
      <div class="recipients-tab-menu">
        <ul class="flex gap-4">
          <li class="icon-action-btn">
            <button
              @click="showResendModal = true"
              class="whitebutton-gemnote button-gemnote--small send-whitebutton-gemnote--small"
              :class="{
                disabled: !selectedGiftCards.length
              }"
            >
              <span>Send</span>
            </button>
          </li>

          <li class="icon-action-btn" v-if="currentFilter.text === 'inactive'">
            <img
              v-tooltip.bottom="{
                content: 'Delete',
                theme: 'default'
              }"
              alt="archive"
              @click="onArchive"
              :class="{
                inactive: !selectedGiftCards.length
              }"
              :src="require('../../assets/delete-enabled.svg')"
            />
          </li>
          <li class="icon-action-btn" v-else>
            <img
              v-tooltip.bottom="{
                content: 'Disable',
                theme: 'default'
              }"
              alt="archive"
              @click="onArchive"
              :class="{
                inactive: !selectedGiftCards.length
              }"
              :src="require('../../assets/archive.svg')"
            />
          </li>
        </ul>
      </div>
    </div>

    <!-- Table -->
    <div v-if="loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>

    <vue-good-table
      v-if="!loadStatus"
      styleClass="vgt-table striped gift-cards-table"
      :columns="columns"
      :rows="resultQuery"
      mode="remote"
      :totalRows="resultQuery.length"
      @on-page-change="handlePageChange"
      :pagination-options="{
        enabled: true,
        perPageDropdownEnabled: false
      }"
    >
      <template slot="table-column" slot-scope="props">
        <span
          v-if="props.column.field == 'select'"
          style="display: flex; justify-content: center;"
        >
          <label class="checkbox-container">
            <input
              type="checkbox"
              :checked="giftCards.length === selectedGiftCards.length"
              @click.stop="handleSelectAllGiftCard"
            />
            <span class="checkmark checkmark-center"></span>
          </label>
          <span style="padding-left: 1.4rem;"> {{ props.column.label }}</span>
        </span>
        <span v-else-if="currentFilter.label == 'Active cards'">
          <span v-if="props.column.field === 'enabled'">
            {{ props.column.label }}
          </span>
          <span v-else class="">
            {{ props.column.label }}
          </span>
        </span>
      </template>

      <template slot="table-row" slot-scope="cards">
        <template v-if="cards.column.field === 'select'">
          <div
            class="form-control icon-control"
            style="width: max-content; margin: 0px auto;"
          >
            <label class="checkbox-container">
              <input
                type="checkbox"
                :checked="selectedGiftCards.includes(cards.row.id)"
                @click.stop="handleGiftCardSelection(cards.row.id)"
              />
              <span class="checkmark checkmark-center"></span>
            </label>
          </div>
        </template>
        <template v-else-if="cards.column.field === 'dateCreated'">
          <span>{{ formatDate(cards.row.createdAt) }}</span>
        </template>
        <template v-else-if="cards.column.field === 'expirationDate'">
          <span>{{
            cards.row.expirationDate
              ? formatDate(cards.row.expirationDate)
              : '-'
          }}</span>
        </template>
        <template v-else-if="cards.column.field === 'sentDate'">
          <span>{{
            cards.row.sentDate ? formatDate(cards.row.sentDate) : '-'
          }}</span>
        </template>
        <template v-else-if="cards.column.field === 'amount'">
          <span>{{ formatCurrency(cards.row.amount) }}</span>
        </template>
        <template v-else-if="cards.column.field === 'outstandingValue'">
          <span>{{ formatCurrency(cards.row.outstandingValue) }}</span>
        </template>
        <template v-else-if="cards.column.field === 'redeemedValue'">
          <span>{{ formatCurrency(cards.row.redeemedValue) }}</span>
        </template>
        <template v-else-if="cards.column.field === 'email'">
          <span class="text-center">{{ cards.row.email || '-' }}</span>
        </template>
        <template v-else-if="cards.column.field === 'code'">
          <span
            v-if="cards.row.code"
            class="flex gap-2 items-center"
            @click="copyCode(cards.row.code)"
          >
            <span>{{ cards.row.code }}</span>
            <img src="../../assets/copy-icon.svg" class="copy-icon" alt=""
          /></span>
          <span
            v-else
            class="flex gap-2 items-center"
            @click="copyCode(cards.row.code)"
          >
            <span> - </span>
          </span>
        </template>

        <span v-else-if="cards.column.field === 'status'">
          {{ cards.row.status | capitalize }}
        </span>
        <template v-else-if="cards.column.field === 'enabled'">
          <div class="form-control icon-control">
            <label class="toggle-button">
              <input
                :disabled="isExpired(cards.row.expirationDate)"
                type="checkbox"
                v-model="cards.row.enabled"
                @click="toggleEnableDisable($event, cards.row)"
              />
              <span class="toggle-slider round"></span>
            </label>
          </div>
        </template>
      </template>
      <div slot="emptystate">No available gift cards to display.</div>
      <template slot="pagination-bottom">
        <Pagination
          v-show="resultQuery.length"
          :total-items="giftCardsTotalCount"
          :page="serverParams.page"
          :items-per-page="serverParams.perPage"
          :showResultsCount="true"
          @page-change="handlePageChange"
          @perPageChange="handePerPageChanged"
        />
      </template>
    </vue-good-table>

    <ExportModal
      :showFooter="true"
      v-show="isExportModalActive"
      @hideModal="closeModal"
      :showCancelButton="false"
      @confirmAction="closeModal"
      colorVariation="coast"
    >
      <template slot="header">
        <span>Exporting Gift Cards</span>
      </template>

      <template slot="body">
        <span>
          We are exporting your order, we will send a link to
          <strong> {{ user.email }} </strong> when it’s done. Keep an eye on
          your inbox!
        </span>
      </template>
    </ExportModal>

    <!-- DeleteModal -->
    <DeleteModal
      :showFooter="true"
      v-show="isDeleteModalActive"
      @hideModal="isDeleteModalActive = false"
      :showCancelButton="true"
      modalName="ConfirmDeleteGiftCardRecipients"
      :buttonLabel="currentFilter.text === 'inactive' ? 'Delete' : 'Disable'"
      colorVariation="secondary"
      @confirmAction="onDeleteGiftCards"
    >
      <template slot="header">
        <span>
          {{
            currentFilter.text === 'inactive'
              ? `${
                  selectedGiftCards.length > 1
                    ? 'Delete Gift Cards'
                    : 'Delete Gift Card'
                }`
              : `${
                  selectedGiftCards.length > 1
                    ? 'Disable gift cards'
                    : 'Disable gift card'
                }`
          }}
        </span>
      </template>
      <template slot="body">
        <div>
          {{
            currentFilter.text === 'inactive'
              ? `${
                  selectedGiftCards.length > 1
                    ? 'Are you sure you want to delete the selected gift cards?'
                    : 'Are you sure you want to delete the selected gift card?'
                }`
              : `${
                  selectedGiftCards.length > 1
                    ? 'Are you sure you want to disable the selected gift cards?'
                    : 'Are you sure you want to disable the selected gift card?'
                }`
          }}
        </div>
      </template>
    </DeleteModal>

    <DeleteModal
      :showFooter="true"
      v-show="showResendModal"
      @hideModal="showResendModal = false"
      :showCancelButton="true"
      modalName="ConfirmDeleteGiftCardRecipients"
      buttonLabel="Send"
      colorVariation="secondary"
      @confirmAction="handleResendGiftCards"
    >
      <template slot="header">
        <span
          >Send Selected Gift
          {{ selectedGiftCards.length > 1 ? 'Cards' : 'Card' }}
        </span>
      </template>
      <template slot="body">
        <div>
          Are you sure you want to send the selected gift
          {{ selectedGiftCards.length > 1 ? 'cards' : 'card' }}?
        </div>
      </template>
    </DeleteModal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import Util from '../../mixins/Util'
import Skeleton from '../Universal/Skeleton'
import Pagination from '@/components/Universal/Pagination'
import SearchAndFilter from '@/components/Universal/Search.vue'
import RadioButton from '@/components/Universal/RadioButton.vue'

export default {
  name: 'EcommerceGiftsCards',
  mixins: [Util],
  components: {
    VueGoodTable,
    Skeleton,
    Pagination,
    SearchAndFilter,
    RadioButton,
    ExportModal: () => import('@/components/Universal/ExportModal'),
    DeleteModal: () => import('@/components/Universal/ExportModal')
  },
  data: () => ({
    isDeleteModalActive: false,
    showResendModal: false,
    filterActive: false,
    sortActive: true,
    file_labels: {
      date: 'Date Created',
      email: 'Email',
      code: 'Code',
      outstanding_value: 'Outstanding Value',
      redeemed_value: 'Redeemed',
      order_no: 'Order#',
      order_date: 'Order Date',
      status: 'Status'
    },
    currentFilter: '',
    currentSort: {
      label: 'None',
      text: 'none'
    },
    filterOptions: [
      {
        label: 'Active cards',
        text: 'active'
      },
      {
        label: 'Inactive cards',
        text: 'inactive'
      },
      {
        label: 'Sent cards',
        text: 'sent'
      },
      {
        label: 'Unsent cards',
        text: 'unsent'
      }
    ],
    sortOptions: [
      {
        label: 'Date created',
        text: 'date_created',
        id: 1,
        showArrow: {
          show: false
        }
      },
      {
        label: 'Highest Value',
        text: 'highest_value',
        id: 2,
        showArrow: {
          show: true,
          state: 'ascending'
        }
      },
      {
        label: 'Lowest Value',
        text: 'lowest_value',
        id: 3,
        showArrow: {
          show: true,
          state: 'decending'
        }
      },

      {
        label: 'Outstanding Value',
        text: 'highest_outstanding_balance',
        id: 4,
        showArrow: {
          show: true,
          state: 'ascending'
        }
      },
      {
        label: 'Outstanding Value',
        text: 'lowest_outstanding_balance',
        id: 5,
        showArrow: {
          show: true,
          state: 'descending'
        }
      },
      {
        label: 'Redeemed Value',
        text: 'highest_redeemed_balance',
        id: 6,
        showArrow: {
          show: true,
          state: 'ascending'
        }
      },
      {
        label: 'Redeemed Value',
        text: 'lowest_redeemed_balance',
        id: 7,
        showArrow: {
          show: true,
          state: 'descending'
        }
      },
      {
        label: 'None',
        text: 'none',
        id: 8,
        showArrow: false
      }
    ],
    searchQuery: '',
    serverParams: {
      page: 0,
      perPage: 10
    },

    dateFilters: [
      {
        label: 'By Date',
        value: 'By Date'
      }
    ],
    dateFilter: 'Filter',

    isFetchingGiftCards: true,
    columns: [
      {
        label: 'Select all',
        field: 'select',
        width: '120px',
        sortable: false
      },
      {
        label: 'Date Created',
        field: 'dateCreated',
        width: '120px',
        sortable: true
      },
      {
        label: 'Name',
        width: '120px',
        field: 'name'
      },
      {
        label: 'Value',
        field: 'amount'
      },
      {
        label: 'Expiration Date',
        field: 'expirationDate',
        width: '120px'
      },
      {
        label: 'Email',
        field: 'email',
        width: '120px'
      },
      {
        label: 'Code',
        field: 'code',
        width: '100px'
      },
      {
        label: 'Outstanding Value',
        field: 'outstandingValue',
        sortable: true
      },
      {
        label: 'Redeemed Value',
        field: 'redeemedValue',
        sortable: true
      },
      {
        label: 'Sent Date',
        field: 'sentDate',
        width: '110px'
      }
    ],
    requestParams: {
      filter: {},
      sort: {},
      search: '',
      page: 1,
      size: 10
    },
    selectedGiftCards: []
  }),
  watch: {
    currentFilter: {
      handler: function(currentFilter) {
        // check is enabled colums exists
        const activeColumnExists = this.columns.find(
          col => col.field === 'enabled'
        )
        if (this.filterActive && currentFilter) {
          if (
            currentFilter.label === 'Active cards' ||
            currentFilter.label === 'Inactive cards'
          ) {
            if (!activeColumnExists) {
              this.columns.push({
                label: 'Enable',
                field: 'enabled',
                width: '110px'
              })
            }
          } else {
            if (activeColumnExists) {
              this.columns.pop()
            }
          }
        } else {
          if (activeColumnExists) {
            this.columns.pop()
          }
        }
      },
      deep: true,
      immediate: true
    },
    currentSort: {
      handler: function() {
        this.serverParams.page = 0
      }
    }
  },
  computed: {
    ...mapState({
      searchTerm: state => state.globalTracking.searchTerm,
      // selectAllGiftCards: state => state.ecommerce.selectAllGiftCards,
      // selectedGiftCards: state => state.ecommerce.selectedGiftCards,
      fetchingGiftCards: state => state.ecommerce.fetchingGiftCards,
      giftCards: state => state.ecommerce.giftCards,
      giftCardsTotalCount: state => state.ecommerce.giftCardsTotalCount,
      isExportModalActive: state => state.modal.isExportModalActive,
      user: state => state.profile.user
    }),

    loadStatus() {
      return this.fetchingGiftCards
    },
    resultQuery() {
      return this.giftCards
    }
  },
  async created() {
    this.getGiftCards()
  },
  methods: {
    isExpired(date) {
      if (!date) return false

      return new Date(date) < new Date()
    },
    toggleEnableDisable(e, card) {
      const payload = {
        requestParams: this.requestParams,
        cardDetails: card
      }
      this.$store.dispatch('ecommerce/toggleGiftCard', payload)
    },
    handleGiftCardSelection(id) {
      const isSelected = this.selectedGiftCards.includes(id)
      if (isSelected) {
        this.selectedGiftCards = this.selectedGiftCards.filter(
          giftCard => giftCard !== id
        )
      } else {
        this.selectedGiftCards.push(id)
      }
    },

    handleSelectAllGiftCard() {
      if (this.selectedGiftCards.length === this.giftCards.length) {
        this.selectedGiftCards = []
      } else {
        this.giftCards.forEach(giftCard => {
          this.selectedGiftCards.push(giftCard.id)
        })
      }
    },

    async onDeleteGiftCards() {
      let formData = new FormData()
      this.selectedGiftCards.forEach(giftCard => {
        formData.append('gift_card_recipient[ids][]', giftCard)
      })
      await this.$store.dispatch('ecommerce/bulkDeleteGiftCards', formData)
      await this.getGiftCards()

      this.selectedGiftCards = []

      this.isDeleteModalActive = false
    },

    handleResendGiftCards() {
      let formData = new FormData()
      let hasValidEmail = true
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

      this.selectedGiftCards.forEach(giftCard => {
        let selectedGiftCardDetails = this.giftCards.find(
          card => card.id === giftCard
        )

        if (selectedGiftCardDetails && selectedGiftCardDetails.email) {
          let validEmail = emailRegex.test(selectedGiftCardDetails.email)

          if (validEmail) {
            formData.append('gift_card_recipient[ids][]', giftCard)
          } else {
            hasValidEmail = false
          }
        } else {
          hasValidEmail = false
        }
      })
      if (hasValidEmail) {
        this.$store.dispatch('ecommerce/resendGiftCards', formData)
        this.selectedGiftCards = []
        this.showResendModal = false
      } else {
        this.showResendModal = false
        this.$store.dispatch('notification/pushNotification', {
          type: 'warning',
          messages: [`Select only gift cards with email(s).`]
        })
      }
    },
    onExportGiftCards() {
      this.$store.dispatch('modal/handleExports', 'e_commerce_gift_cards')
    },
    closeModal() {
      this.$store.dispatch('modal/setExportModal', false)
    },
    copyCode(code) {
      this.$copyText(code).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Gift  Code copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Unable to copy Gift Code Key.`]
          })
          console.log(error)
        }
      )
    },
    handlePageChange(page) {
      this.isFetchingGiftCards = true
      this.serverParams.page = page
      this.requestParams.page = this.serverParams.page + 1
      this.getGiftCards()
      this.selectedGiftCards = []
    },
    handePerPageChanged(size) {
      this.isFetchingGiftCards = true
      this.requestParams.size = size
      this.serverParams.perPage = size
      this.getGiftCards()
    },
    async getGiftCards() {
      this.selectAllGiftCards = []
      setTimeout(() => {
        this.isFetchingGiftCards = false
      }, 2000)
      await this.$store.dispatch(
        'ecommerce/getAllGiftCards',
        this.requestParams
      )
    },
    onFilterChange(val) {
      this.requestParams.filter = {
        [val.text]: true
      }

      this.dateFilter = val
      this.filterActive = true
      this.serverParams.page = 0
      this.requestParams.page = this.serverParams.page + 1

      this.getGiftCards()
    },
    onSort({ label, text }) {
      this.sortFilter = label
      this.sortActive = true
      this.serverParams.page = 0
      this.requestParams.page = this.serverParams.page + 1

      if (text === 'none') {
        this.requestParams.sort = {}
      } else {
        this.requestParams.sort = {
          [text]: true
        }
      }

      this.getGiftCards()
    },

    setDateFilter() {
      this.dateFilter = 'Filter'
      // this.isFetchingGiftCards = true
      this.getGiftCards()
    },

    onSearchSearch(value) {
      this.searchQuery = value
      this.requestParams.search = this.searchQuery
      this.serverParams.page = 0
      this.requestParams.page = this.serverParams.page + 1
      this.getGiftCards()
    },

    removeFilterTag() {
      this.requestParams.filter = {}
      this.getGiftCards()
      this.currentFilter = ''
      this.filterActive = false
      // this.isFetchingGiftCards = true
      this.getGiftCards()
    },
    removeSortTag() {
      this.getGiftCards()
      this.requestParams.sort = {}
      this.currentSort = {
        label: 'None',
        text: 'none'
      }
      this.getGiftCards()
    },
    onArchive() {
      if (this.selectedGiftCards.length) {
        this.isDeleteModalActive = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.gift-card-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: flex-end;
  padding: 1.25rem 0;

  .search-input {
    width: 30%;
  }

  .button-gemnote {
    font-weight: normal;
    height: 2.5rem;
    padding: 0 18px;

    span {
      margin-left: 6px;
    }
  }
}
.whitebutton-gemnote--small {
  padding: 0 1.25rem;
  height: 2.5rem;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  span.small {
    font-size: 0.89rem;
  }

  .dateFilter {
    min-width: 120px;
    display: flex;
    gap: 0.4rem;
    align-items: center;
    padding-left: 6px;

    .v-select {
      width: 100%;
    }
    .light {
      border: none !important;
    }
    .button-gemnote--small {
      background: transparent;
    }
  }

  .filter-tag {
    min-width: max-content;
    position: relative;
    cursor: pointer;
    font-family: 'Nunito Sans';
    background-color: #dfdad2;
    font-size: 0.665rem;
    color: #24292c;
    margin: 0 6px;
    padding: 4px 14px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 0.775rem;

    .remove {
      cursor: pointer;
      padding-left: 8pt;
      text-decoration: none;
      font-size: 0.675rem;
    }
  }

  .clear-filter-tag {
    font-weight: 700;
    font-size: 0.925rem;
    text-decoration: underline;
  }
}
.toggle-slider:before {
  background: #dfdad2;
}
.toggle-slider.round {
  background: #232220;
}

input:disabled + .toggle-slider {
  background-color: #dfdad2 !important;
  cursor: not-allowed;
}

input:checked + .toggle-slider {
  background-color: #68c67e;
}

.icon-action-btn {
  display: flex !important;
  align-items: center;

  img {
    cursor: pointer;
    width: 90%;
  }

  .inactive {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.white-button-gemnote--disabled {
  opacity: 0.5;
}
.button-gemnote--small {
  padding: 0 1.25rem;
  height: 2rem;
}
.send-whitebutton-gemnote--small {
  font-size: 0.75rem;
  background: #dfdad2 !important;
  height: 1.8rem;

  &.disabled {
    opacity: 0.8;
    color: #a09c95 !important;
    border: 1px solid #a09c95 !important;
    background: #dfdad2 !important;
    cursor: not-allowed;
  }
}
.copy-icon {
  width: 10px;
  height: 100%;
  cursor: pointer;
}
input {
  background-color: red !important;
}

@media (max-width: 420px) {
  .filters {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
  }
}
@media screen and (max-width: 630px) and (min-width: 350px) {
  .gift-card-button-wrapper {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: flex-start;
    &.justify-end {
      align-items: flex-end;
      justify-content: end !important;
    }
    .search-input {
      flex: 0;
    }
  }
}
</style>
